export default __webpack_public_path__ + "static/media/5.679bc5a4.jpg";